import { render, staticRenderFns } from "./xunjiantaizhang.vue?vue&type=template&id=a5bda79a&scoped=true"
import script from "./xunjiantaizhang.vue?vue&type=script&lang=js"
export * from "./xunjiantaizhang.vue?vue&type=script&lang=js"
import style0 from "./xunjiantaizhang.vue?vue&type=style&index=0&id=a5bda79a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5bda79a",
  null
  
)

export default component.exports